import { ElementBuilder } from "@universityofmaryland/web-builder-library";
import * as token from "@universityofmaryland/web-token-library";
import * as typography from "@universityofmaryland/web-styles-library/typography";
import * as layout from "@universityofmaryland/web-styles-library/layout";
import * as elementStyles from "@universityofmaryland/web-styles-library/element";
import { theme } from "@universityofmaryland/web-utilities-library/theme";
import { phone, email } from "@universityofmaryland/web-icons-library/communication";
import { pin } from "@universityofmaryland/web-icons-library/location";
import { linkedin, bluesky, substack } from "@universityofmaryland/web-icons-library/social";
const makeIcon = ({
  icon,
  isThemeDark
}) => {
  return new ElementBuilder("span").withHTML(icon).styled(
    elementStyles.action.icon.composeIcon({
      theme: theme.variant(isThemeDark)
    })
  ).withStyles({
    element: {
      alignSelf: "flex-start"
    }
  }).build();
};
const makeText = ({
  text,
  isThemeDark
}) => {
  return new ElementBuilder("span").withHTML(text).styled(
    typography.sans.compose("smaller", {
      theme: theme.fontColor(isThemeDark)
    })
  ).withStyles({
    element: {
      ...!isThemeDark && { color: `${token.color.gray.dark}` }
    }
  }).build();
};
const makeContactLink = ({
  element,
  icon,
  isThemeDark
}) => {
  const isLink = element.getAttribute("href") && icon !== pin;
  const textSpan = makeText({ text: element.innerHTML, isThemeDark });
  const iconSpan = makeIcon({ icon, isThemeDark });
  const containerStyles = {
    element: {
      marginTop: "4px",
      lineHeight: "1.2em",
      [`&a:hover, &a:focus`]: {
        textDecoration: "underline",
        ...isThemeDark && {
          color: `${token.color.white}`
        }
      }
    }
  };
  if (isLink) {
    const ariaLabel = element.getAttribute("aria-label");
    const href = element.getAttribute("href") || "";
    const linkBuilder = new ElementBuilder("a").styled(layout.grid.inline.row).withStyles(containerStyles).withChildren(iconSpan, textSpan).withAttribute("href", href);
    if (ariaLabel) {
      linkBuilder.withAttribute("aria-label", ariaLabel);
    }
    return linkBuilder.build();
  }
  return new ElementBuilder().styled(layout.grid.inline.row).withStyles(containerStyles).withChildren(iconSpan, textSpan).build();
};
const createTextLockupContact = ({
  actions,
  address,
  email: email$1,
  isThemeDark,
  linkedin: linkedin$1,
  bluesky: bluesky$1,
  substack: substack$1,
  phone: phone$1
}) => {
  const container = new ElementBuilder().withClassName("text-lockup-contact").withStyles({
    element: {
      marginTop: `${token.spacing.sm}`
    }
  });
  if (phone$1) {
    const phoneElement = new ElementBuilder().withClassName("text-lockup-contact-phone").withChild(
      makeContactLink({ element: phone$1, icon: phone, isThemeDark })
    ).build();
    container.withChild(phoneElement);
  }
  if (email$1) {
    const emailElement = new ElementBuilder().withClassName("text-lockup-contact-email").withChild(
      makeContactLink({ element: email$1, icon: email, isThemeDark })
    ).build();
    container.withChild(emailElement);
  }
  if (linkedin$1) {
    const linkedInElement = new ElementBuilder().withClassName("text-lockup-contact-linkedin").withChild(
      makeContactLink({
        element: linkedin$1,
        icon: linkedin,
        isThemeDark
      })
    ).build();
    container.withChild(linkedInElement);
  }
  if (bluesky$1) {
    const blueSkyElement = new ElementBuilder().withClassName("text-lockup-contact-bluesky").withChild(
      makeContactLink({
        element: bluesky$1,
        icon: bluesky,
        isThemeDark
      })
    ).build();
    container.withChild(blueSkyElement);
  }
  if (substack$1) {
    const substackElement = new ElementBuilder().withClassName("text-lockup-contact-substack").withChild(
      makeContactLink({
        element: substack$1,
        icon: substack,
        isThemeDark
      })
    ).build();
    container.withChild(substackElement);
  }
  if (address) {
    const addressElement = new ElementBuilder().withClassName("text-lockup-contact-address").withChild(
      makeContactLink({ element: address, icon: pin, isThemeDark })
    ).build();
    container.withChild(addressElement);
  }
  if (actions) {
    const actionsElement = new ElementBuilder(actions).styled(layout.grid.inline.tabletRows).withStyles({
      element: {
        marginTop: token.spacing.sm
      }
    }).build();
    container.withChild(actionsElement);
  }
  return container.build();
};
export {
  createTextLockupContact
};
//# sourceMappingURL=contact.js.map
